var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CollapseTransition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"col-12 row justify-center q-py-sm bg-white border-radius-8 border-box q-mt-sm"},[_c('q-spinner-ios',{staticClass:"col-auto q-mx-auto",attrs:{"size":"35px","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }